module.exports = __webpack_public_path__ + "img/Number=79.bcb18aaa.png";